module.exports = __webpack_public_path__ + "img/advance-1-1.svg";